/* eslint-disable no-unused-vars,@typescript-eslint/no-unused-vars */
import { IModel } from '@src/js/separate-logic/interface/IModel';

export default class CellWrapperModel implements IModel {
    public initModel() {}
}
